import script from "./HoldingExpandModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HoldingExpandModal.vue?vue&type=script&setup=true&lang=ts"

import "./HoldingExpandModal.vue?vue&type=style&index=0&id=c6b4a0a6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6b4a0a6"]])

export default __exports__